/* IM8 Essentials Pro — shared FX for split sections.
   Document-wide scroll-reveal + live order-count. Runs once (guarded), even if
   referenced by multiple sections. Reveal targets are tagged across the page;
   one IntersectionObserver drives them. Respects prefers-reduced-motion. */
(function () {
  if (window.__im8EpFx) return;
  window.__im8EpFx = 1;

  function init() {
    /* ---- scroll reveal ---- */
    try {
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
      if (('IntersectionObserver' in window) && !reduce) {
        document.querySelectorAll('.ep-lp').forEach(function (r) { r.classList.add('ep-anim'); });
        var sels = ['.ep-advisory', '.ep-reason', '.ep-midcta__box', '.ep-systems .ep-kicker', '.ep-systems h2', '.ep-systems__copy', '.ep-system-card', '.ep-center', '.ep-dose-card', '.ep-dose-foot', '.ep-panel', '.ep-timeline__head', '.ep-step', '.ep-beckham__box', '.ep-plans__head', '.ep-plan', '.ep-plan-options', '.ep-guarantee__card', '.ep-faq h2', '.ep-faq details', '.ep-final .ep-kicker', '.ep-final h2', '.ep-final p', '.ep-final .ep-btn'];
        var els = [];
        sels.forEach(function (s) { document.querySelectorAll(s).forEach(function (n) { els.push(n); }); });
        els.forEach(function (e) { e.classList.add('ep-reveal'); });
        var grids = ['.ep-system-grid', '.ep-dose-grid', '.ep-timeline__grid', '.ep-kit__grid', '.ep-compare__grid'];
        grids.forEach(function (g) {
          document.querySelectorAll(g).forEach(function (gn) {
            var kids = gn.children;
            for (var k = 0; k < kids.length; k++) {
              if (kids[k].classList && kids[k].classList.contains('ep-reveal')) kids[k].style.transitionDelay = (k * 80) + 'ms';
            }
          });
        });
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('ep-in'); io.unobserve(x.target); } });
        }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
        els.forEach(function (e) { io.observe(e); });
        setTimeout(function () { els.forEach(function (e) { var r = e.getBoundingClientRect(); if (r.top < window.innerHeight) e.classList.add('ep-in'); }); }, 1200);
      }
    } catch (e) {}

    /* ---- live customer-purchases + servings (shared homepage source) ---- */
    try {
      if (!window.im8OrderData) {
        var api = 'https://im8-order-count.vercel.app/api/exact-order-count';
        window.im8OrderData = new Promise(function (res) {
          var c = new AbortController();
          setTimeout(function () { c.abort(); }, 2500);
          fetch(api + '?maxAgeMinutes=1440', { signal: c.signal }).then(function (r) { return r.json(); }).then(function (d) { res(d && d.status === 'COMPLETED' && isFinite(d.exactOrders) ? d.exactOrders : null); }).catch(function () { res(null); });
        });
      }
      window.im8OrderData.then(function (orders) {
        if (!orders || !isFinite(orders)) return;
        var cust = (Math.floor(orders / 10000) * 10000).toLocaleString('en-US') + '+';
        var serv = Math.round(orders * 50.88 / 1000000) + ' million';
        document.querySelectorAll('[data-ep-live="customers"]').forEach(function (e) { e.textContent = cust; });
        document.querySelectorAll('[data-ep-live="servings"]').forEach(function (e) { e.textContent = serv; });
      });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
